import { combineReducers }   from 'redux-immutable';
import buildByIdReducer      from './buildByIdReducer';
import buildIdsBySlugReducer from './buildIdsBySlugReducer';


const buildAllItemsReducers = (resource) => combineReducers({
  byIds:     buildByIdReducer(resource),
  idsBySlug: buildIdsBySlugReducer(resource),
});


export default buildAllItemsReducers;


// WEBPACK FOOTER //
// ./src/reducers/utils/apiResources/items/buildAllItemsReducers.js